import { createFeatureHub } from '@feature-hub/core';
import { defineExternals, loadAmdModule } from '@feature-hub/module-loader-amd';
import { FeatureHubContextProvider } from '@feature-hub/react';
import { SerializedStateManagerV1 } from '@feature-hub/serialized-state-manager';
import { Breakpoints } from '@vw-marketing/us-components';
import { ShowroomNavigationManagerV1 } from '@volkswagen-onehub/showroom-navigation';

import { defineTrackingService } from '@volkswagen-onehub/tracking-service';
//import {LayerManagerV2} from '@volkswagen-onehub/layer-manager';

import lazySizes from 'lazysizes';
import React from 'react';
import ReactDOM from 'react-dom';
import { configureCommonFeatureServices } from './configure-common-feature-services';
import { createOptionsFromQueryParams } from './create-options-from-query-params';
import { createQueryParamsFromLocation } from './create-query-params-from-location';
import { defineCommonFeatureServices } from './define-common-feature-services';
import { externals } from './externals';
import { Integrator } from './integrator';

import { appsUMD } from './app-constants';
interface TrackingEvent {
  readonly eventInfo: {
    readonly eventAction: string;
  };

  readonly [key: string]: object;
}

lazySizes.cfg.init = false;

defineExternals(externals);

(async () => {
  const queryParams = createQueryParamsFromLocation();
  const options = createOptionsFromQueryParams(queryParams);
  const featureServiceDefinitions = await defineCommonFeatureServices(options);
  const { countryCode, language, mode, featureAppName } = options;

  const {
    carConfigurationServiceDefinition,
    showroomNavigationManagerDefinition,
    serializedStateManagerDefinition,
    layerManagerDefinition,
  } = featureServiceDefinitions;

  const trackingServiceDefinition = defineTrackingService({
    breakPoints: [
      Breakpoints.b560,
      Breakpoints.b960,
      Breakpoints.b1280,
      Breakpoints.b1600,
      Breakpoints.b1920,
      Breakpoints.b2560,
    ],
    environmentData: {
      applicationId: 'ngw6fa Integrator',
      country: countryCode,
      language,
      featureAppId: mode === 'module' ? 'module' : 'standalone',
    },
    provider: {
      push: (event: TrackingEvent) => {
        console.groupCollapsed(
          `Tracking Event: ${event.eventInfo.eventAction}`,
        );

        for (const key of Object.keys(event)) {
          console.group(key);
          console.table(event[key]);
          console.groupEnd();
        }

        console.groupEnd();
      },
    },
    navigationDataFn: () => ({}),
  });

  const { featureAppManager, featureServices } = createFeatureHub(
    'ngw6fa-integrator',
    {
      moduleLoader: loadAmdModule,
      featureServiceDefinitions: [
        ...Object.values(featureServiceDefinitions),
        trackingServiceDefinition,
      ],
      featureServiceDependencies: {
        [carConfigurationServiceDefinition.id]: '^1.0.0',
        [showroomNavigationManagerDefinition.id]: '^1.1.0',
        [serializedStateManagerDefinition.id]: '^1.0.0',
        [layerManagerDefinition.id]: '^2.0.0',
      },
    },
  );

  configureCommonFeatureServices(featureServices, options);

  // const layerManager = featureServices[
  //   layerManagerDefinition.id
  // ] as LayerManagerV2;

  const { history } = featureServices[
    showroomNavigationManagerDefinition.id
  ] as ShowroomNavigationManagerV1;

  const serializedStateManager = featureServices[
    serializedStateManagerDefinition.id
  ] as SerializedStateManagerV1;

  const serializedStatesElement = document.querySelector(
    'script[type="x-mofa/serialized-states"]',
  );

  const serializedStates = serializedStatesElement?.textContent;

  if (serializedStates) {
    serializedStateManager.setSerializedStates(serializedStates);
  }

  const integratorElement = (
    <FeatureHubContextProvider value={{ featureAppManager }}>
      <Integrator history={history} {...options} />
    </FeatureHubContextProvider>
  );

  if (options.ssr) {
    await featureAppManager.preloadFeatureApp(appsUMD[featureAppName]);

    ReactDOM.hydrate(integratorElement, document.getElementById('root'));
  } else {
    ReactDOM.render(integratorElement, document.getElementById('root'));
  }

  lazySizes.init();
})().catch(console.error);
